module.exports = __webpack_public_path__ + "static/media/DejaVuSerif.a4108b7c.ttf";